import { useSelector } from 'react-redux';
import { useFlags } from '@rsos/flags';
import { selectActiveCapabilities } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import type { SinatraState } from '@rsos/sinatra';
import type { SideBarMenuItem } from './types';
import { shouldSideBarItemRender } from './utils';

interface SideBarState {
  sinatra: SinatraState;
}

/**
 * Filters the sidebar items to those the current user should see, based on
 * feature flags, page permissions, and org capabilities.
 */
export default function useRenderSideBarItems(
  sideBarItems: SideBarMenuItem[] = [],
): SideBarMenuItem[] {
  const flags = useFlags();
  const activeCapabilities = useSelector(selectActiveCapabilities);
  const pageAccessList = useSelector(
    (state: SideBarState) => state.sinatra.user.pageAccessList,
  );

  return sideBarItems.filter(item =>
    shouldSideBarItemRender(
      item,
      flags,
      activeCapabilities,
      pageAccessList || [],
    ),
  );
}
